export const InvalidateDashboardQueries = (queryClient) => {
    queryClient.invalidateQueries({ queryKey: ["arriving"] });
    queryClient.invalidateQueries({ queryKey: ["unloading"] });
    queryClient.invalidateQueries({ queryKey: ["emptied"] });
    queryClient.invalidateQueries({ queryKey: ["arriving-prev-next"] });
    queryClient.invalidateQueries({ queryKey: ["unloading-prev-next"] });
    queryClient.invalidateQueries({ queryKey: ["calendarContainersData"] });
    queryClient.invalidateQueries({ queryKey: ["containersData"] });
    queryClient.invalidateQueries({ queryKey: ["shipmentCounts"] });
    queryClient.invalidateQueries({ queryKey: ["shipments"] });
    queryClient.invalidateQueries({ queryKey: ["containerSearch"] });
    queryClient.invalidateQueries({ queryKey: ["nextDeliveryDate"] });
    queryClient.invalidateQueries({ queryKey: ["warehouseShipments"] });
    queryClient.invalidateQueries({ queryKey: ["homepageData"] });
};